<template>
  <div class="pagination-wrapper">
    <ul class="pagination" v-if="totalPages > 1">
      <li v-if="currentPage > 1">
        <a @click="setPage(1)">
          <font-awesome-icon icon="angle-double-left"/>
        </a>
      </li>
      <li v-if="currentPage > 1">
        <a @click="setPage(currentPage - 1)">
          <font-awesome-icon icon="angle-left"/>
        </a>
      </li>
      <li v-for="pageNumber in totalPages" :key="pageNumber"
          v-if="Math.abs(pageNumber - currentPage) < 3 || pageNumber == totalPages || pageNumber == 1">
        <a v-bind:key="pageNumber" @click="setPage(pageNumber)"
           :class="{current: currentPage === pageNumber,
                    last: (pageNumber == totalPages && Math.abs(pageNumber - currentPage) > 3),
                    first:(pageNumber == 1 && Math.abs(pageNumber - currentPage) > 3)}">
          {{ pageNumber }}</a>
      </li>

      <li v-if="currentPage < totalPages">
        <a @click="setPage(currentPage + 1)">
          <font-awesome-icon icon="angle-right"/>
        </a>
      </li>
      <li v-if="currentPage < totalPages">
        <a @click="setPage(totalPages)">
          <font-awesome-icon icon="angle-double-right"/>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'pagination',
    props: ['itemsPerPage', 'resultCount'],
    data () {
      return {
        currentPage: 1
      }
    },
    computed: {
      totalPages () {
        return Math.ceil(this.resultCount / this.itemsPerPage)
      }
    },
    methods: {
      setPage (pageNumber) {
        this.currentPage = pageNumber
        this.$emit('change', this.currentPage)
      }
    }
  }
</script>

<style scoped lang="scss">
  .pagination-wrapper {
    text-align: right;
  }

  .pagination {
    padding: 0;
    font-size: 0;
    margin: 27px 0 18px 0;
    a {
      color: $blue;
      height: 30px;
      line-height: 30px;
      min-width: 30px;
      box-sizing: border-box;
      padding: 0 5px;
      text-align: center;
      display: block;
      font-size: 14px;
      cursor: pointer;
      transition: background-color .2s linear;
      path {
        fill: $blue;
      }
      &:hover {
        background-color: $blue;
        color: #fff;
        path {
          fill: #fff;
        }
      }
    }
    .current {
      /*color: red;*/
      color: #fff;
      background-color: $blue;
    }
    ul {
      padding: 0;
      list-style-type: none;
    }
    li {
      display: inline-block;
      border: 1px solid $light-blue;
      border-right: 0;
      &:first-child {
        border-radius: 4px 0 0 4px;
      }
      &:last-child {
        border-right: 1px solid $light-blue;
        border-radius: 0 4px 4px 0;
      }
    }

    a.first::after {
      content: '...'
    }

    a.last::before {
      content: '...'
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue